import './styles/job-filter-panel.scss'

import React from "react";
import PropTypes from "prop-types";
import { Button } from 'semantic-ui-react'

import api from "../redux/api";
import JobStatusDropdown from "./JobStatusDropdown";
import AsyncFilterDropdown from "../components/AsyncFilterDropdown";
import DateTimeRangeFilter from '../components/DateTimeRangeFilter'
import AdvancedFilterModal from './AdvancedFilterModal'
import AppliedFilterDisplay from './AppliedFilterDisplay'

export default class JobFilter extends React.Component {
  static propTypes = {
    onFilterChange: PropTypes.func.isRequired,
    filterCriteria: PropTypes.object.isRequired,
  }

  state = {}

  updateFilterSlice = (slice, value) => {
    const { filterConfig } = this.state

    const newFilterConfig = { ...filterConfig, [slice]: value }

    this.setState(({ filterConfig: newFilterConfig }), () => {
      this.props.onFilterChange(newFilterConfig)
    })    
  }

  handleSenderChange   = (data) => this.updateFilterSlice("senderFilter", data && data.value)
  handleReceiverChange = (data) => this.updateFilterSlice("receiverFilter", data && data.value)
  handleDataTypeChange = (data) => this.updateFilterSlice("dataTypeFilter", data && data.value)

  handleStatusFilterChange = (data) => {
    const statusFilters = []

    const filter = (data && data.filter) || []
    statusFilters.push(...filter)

    this.updateFilterSlice("statusFilters", statusFilters)
  }

  handleCreatedTimeChange = (params) => {
    this.updateFilterSlice('createdTimeFilter', params)
  }

  handleAdvancedFilterApply = (advancedFilterConfig) => {
    const { filterConfig } = this.state
    const newFilterConfig = { ...filterConfig, ...advancedFilterConfig }
    this.setState({ filterConfig: newFilterConfig }, () => {
      this.props.onFilterChange(newFilterConfig)
    })
  }

  handleAppliedFilterChange = (appliedFilterConfig) => {
    const { filterConfig } = this.state
    const newFilterConfig = { ...filterConfig, ...appliedFilterConfig }
    this.setState({ filterConfig: newFilterConfig }, () => {
      this.props.onFilterChange(newFilterConfig)
    })
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.filterCriteria && props.filterCriteria.jobs) {
      this.setState({ filterConfig: props.filterCriteria.jobs })
    } else {
      this.setState({ filterConfig: {} })
    }
  }

  handleRefresh = () => {
    this.props.onFilterChange(this.state.filterConfig)
  }

  getFilterValue(filterKey) {
    return this.props.filterCriteria
      && this.props.filterCriteria.jobs
      && this.props.filterCriteria.jobs[filterKey]
  }
  
  render() {
    const timeFilterConfig = {}
    const timeFilter = this.getFilterValue('createdTimeFilter')

    timeFilterConfig.before = timeFilter && timeFilter.before
    timeFilterConfig.after  = timeFilter && timeFilter.after
    
    return (
      <div className="filter-panel">
        <div className="filter-row">
          <div className="filter-field sender">
            <AsyncFilterDropdown
              test={true}
              className="sender-dropdown"
              getOptionsByFilter={api.loadDataSystems}
              placeholder="Filter by Sender"
              onChange={this.handleSenderChange}
              value={this.getFilterValue('senderFilter')}
            />
          </div>
          <div className="filter-field receiver">
            <AsyncFilterDropdown
              className="receiver-dropdown"
              getOptionsByFilter={api.loadDataSystems}
              placeholder="Filter by Receiver"
              onChange={this.handleReceiverChange}
              value={this.getFilterValue('receiverFilter')}
            />
          </div>
          <div className="filter-field data-type">
            <AsyncFilterDropdown
              className="data-type-dropdown"
              getOptionsByFilter={api.loadDataTypes}
              placeholder="Filter by Data Type"
              onChange={this.handleDataTypeChange}
              value={this.getFilterValue('dataTypeFilter')}
            />
          </div>
          <div className="filter-field status">
            <JobStatusDropdown
              placeholder="Filter by Status"
              onChange={this.handleStatusFilterChange}
              value={this.getFilterValue('statusFilters')} />
          </div>
          <div className="filter-field created-time">
            <DateTimeRangeFilter
              onChange={this.handleCreatedTimeChange}
              defaultFilterConfig={timeFilterConfig} />
          </div>
          <div className="filter-field actions">
            <AdvancedFilterModal trigger={<Button icon="filter" primary />} onApply={this.handleAdvancedFilterApply} />
            <Button icon="refresh" onClick={this.handleRefresh} />
          </div>
        </div>
        <div className="filter-row">
          <AppliedFilterDisplay onChange={this.handleAppliedFilterChange}/>
        </div>
      </div>
    )
  }
}
